import axios from 'axios'

export default {
  state: {
    appAndServer: [
      { label: '官方区', value: 1010 }
    ]
  },
  mutations: {
    ChangeServer (state, { logicalRegionId, servers }) {
      const target = state.appAndServer.find(item => item.value === logicalRegionId)
      if (target) {
        target.servers = servers
        state.appAndServer = [...state.appAndServer]
      }
    }
  },
  actions: {
    fetchServersByLogicalRegionId ({ commit, state }, logicalRegionId) {
      const appAndServer = state.appAndServer
      const target = appAndServer.find(item => item.value === logicalRegionId)
      if (target && target.servers === undefined) {
        axios.get(`/api/interface/personal_center/get_server_id?game_id=104&logical_region_id=${logicalRegionId}`).then(res => {
          if (res.data.state === 0) {
            commit('ChangeServer', {logicalRegionId, servers: res.data.data})
          }
        })
      }
    }
  },
  getters: {
    appAndServer: state => state.appAndServer
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js